import React from 'react';
import Icon from './Icon';

export default class DhabiIcon extends Icon {
  icon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="150"
      height="175"
      viewBox="0 0 150 175"
    >
      <defs>
        <path id="a" d="M0 0h45.349v42.968H0z" />
        <path id="c" d="M0 0h45.349v42.968H0z" />
        <path id="e" d="M0 0h84.884v98.71H0z" />
        <path
          id="g"
          d="M10.886 45.838c9.017 13.476 10.972 34.708 12.127 35.321 4.204 2.234 13.57.345 12.986-2.3-.237-1.08-6.419-27.607-20.592-41.39C1.405 23.852 5.607.468 4.165.127A.187.187 0 0 0 4.114.12C2.288.12-5.896 20.758 10.886 45.838"
        />
        <path
          id="i"
          d="M2.702 0C.005 0-.81 1.497.885 3.346l4.185 4.56c1.693 1.844 4.444 1.847 6.14 0l4.185-4.56C17.09 1.499 16.277 0 13.578 0H2.702z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(0 55.742)">
          <mask id="b" fill="#fff">
            <use xlinkHref="#a" />
          </mask>
          <path
            fill="#FACF58"
            d="M32.802 40.978C6.402 31.566-2.33 4.626.512 1.352c2.515-2.891 32.29-3.59 38.641 23.949 1.682 7.297 5.907 12.228 6.173 14.684.437 4.062-5.346 3.552-12.524.993"
            mask="url(#b)"
          />
        </g>
        <path
          fill="#F4A335"
          d="M24.29 85.88C9.188 80.36 9.302 65.032 9.302 65.032s14.356.818 21.745 16.817c1.835 3.974 4.843 5.34 4.993 6.782.253 2.382-7.644-1.25-11.75-2.751"
        />
        <g transform="translate(104.651 55.742)">
          <mask id="d" fill="#fff">
            <use xlinkHref="#c" />
          </mask>
          <path
            fill="#FACF58"
            d="M12.547 40.978C38.945 31.566 47.679 4.626 44.836 1.352c-2.515-2.891-32.29-3.59-38.64 23.949C4.514 32.598.289 37.529.024 39.985c-.437 4.062 5.346 3.552 12.524.993"
            mask="url(#d)"
          />
        </g>
        <path
          fill="#F4A335"
          d="M125.709 85.88c15.102-5.519 14.99-20.848 14.99-20.848s-14.358.818-21.746 16.817c-1.834 3.974-4.842 5.34-4.993 6.782-.25 2.382 7.644-1.25 11.749-2.751"
        />
        <g transform="translate(31.395 75.484)">
          <mask id="f" fill="#fff">
            <use xlinkHref="#e" />
          </mask>
          <path
            fill="#F4A335"
            d="M0 42.917C0 10.926 19.002 0 42.442 0s42.442 10.926 42.442 42.917S62.797 98.71 42.442 98.71C22.088 98.71 0 74.908 0 42.917"
            mask="url(#f)"
          />
        </g>
        <path
          fill="#FACF58"
          d="M65.673 157.847c4.568-1.692.202-26.705-12.088-40.443-12.29-13.74-10.61-25.662-10.61-25.662s-16.323 21.616-5.612 44.214c14.036 29.611 26.23 22.662 28.31 21.891"
        />
        <path
          fill="#F5D577"
          d="M82.002 157.847c-4.57-1.692-.203-26.705 12.087-40.443 12.29-13.74 10.61-25.662 10.61-25.662s16.324 21.616 5.613 44.214c-14.037 29.611-26.231 22.662-28.31 21.891"
        />
        <path
          fill="#FACF58"
          d="M75 150.98c-11.851-3.75-20.349 4.782-20.349 11.504.001 9.196 7.965 11.652 20.349 11.71 12.383-.058 20.349-2.514 20.349-11.71 0-6.722-8.175-15.969-20.349-11.505"
        />
        <path
          fill="#F4A335"
          d="M95.191 136.232c-4.266 6.42-6.4 10.204-8.443 14.192-4.392-2.848-7.06-4.976-11.928-5.022-4.866.046-7.328 2.045-11.722 4.893-1.888-3.86-4.948-11.222-8.649-14.063l-.517.701c3.13 2.406 8.038 16.357 8.038 16.357 5.619-2.21 10.454-1.45 12.85-1.45 2.397 0 7.233-.76 12.851 1.45 0 0 4.908-13.95 8.037-16.357 0 0 3.75-7.123-.517-.701"
        />
        <path
          fill="#302720"
          d="M85.025 78.86c.238-1.082 6.42-27.607 20.593-41.391C119.62 23.85 115.418.468 116.859.126c1.717-.405 10.224 20.389-6.72 45.712-9.018 13.475-10.973 34.708-12.127 35.32-4.206 2.235-13.57.344-12.987-2.299"
        />
        <g transform="translate(29.07)">
          <mask id="h" fill="#fff">
            <use xlinkHref="#g" />
          </mask>
          <path
            fill="#302720"
            d="M10.886 45.838c9.017 13.476 10.972 34.708 12.127 35.321 4.204 2.234 13.57.345 12.986-2.3-.237-1.08-6.419-27.607-20.592-41.39C1.405 23.852 5.607.468 4.165.127A.187.187 0 0 0 4.114.12C2.288.12-5.896 20.758 10.886 45.838"
            mask="url(#h)"
          />
        </g>
        <g>
          <path
            fill="#302720"
            d="M94.186 126.582a5.811 5.811 0 0 1 5.814-5.808c3.21 0 5.814 2.6 5.814 5.808 0 3.205-2.604-1.163-5.814-1.163s-5.814 4.368-5.814 1.163"
          />
          <path
            fill="#FDFFFF"
            d="M89.597 116.825c.25 1.258 3.55 2.002 7.365 1.662 3.82-.34 6.712-1.637 6.464-2.895-.25-1.259-3.55-2-7.366-1.66-3.82.34-6.714 1.636-6.463 2.893"
          />
          <path
            fill="#302720"
            d="M56.977 126.582a5.81 5.81 0 0 0-5.814-5.808 5.81 5.81 0 0 0-5.814 5.808c0 3.205 2.602-1.163 5.814-1.163 3.211 0 5.814 4.368 5.814 1.163"
          />
          <path
            fill="#FDFFFF"
            d="M59.194 117.012c-.327 1.251-3.67 1.905-7.464 1.46-3.794-.443-6.6-1.818-6.273-3.068.33-1.25 3.671-1.902 7.463-1.459 3.794.444 6.603 1.818 6.274 3.067"
          />
        </g>
        <g transform="translate(66.28 149.806)">
          <mask id="j" fill="#fff">
            <use xlinkHref="#i" />
          </mask>
          <path
            fill="#EC6E52"
            d="M-5.814 15.097h27.907V-5.806H-5.814z"
            mask="url(#j)"
          />
        </g>
        <path
          fill="#302720"
          d="M83.72 162.58c0 5.807-17.44 5.807-17.44 0 0 0 6.6 1.165 8.826 1.162 2.173-.004 8.615-1.161 8.615-1.161"
        />
      </g>
    </svg>
  );
}
